import classNames from 'classnames'
import React, { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { ReactComponent as SlidesIcon } from 'partner360/components/trainingCentre/assets/slides.svg'
import { ReactComponent as VideoIcon } from 'partner360/components/trainingCentre/assets/video.svg'
import { TrainingCentreHighlight } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreContent/components/common/trainingCentreHighlight/TrainingCentreHighlight'
import { TRANSLATION_KEYS } from 'partner360/components/trainingCentre/translations'
import { ITrainingSection } from 'partner360/models/trainingCentre/ITrainingCentre'

import styles from './TrainingTopicContent.module.scss'

interface ITrainingTopicContentProps {
  selectedTopicId: string | null
  sections: ITrainingSection[]
  expandedSections: string[]
  onToggleSection: (sectionTitle: string) => void
  searchValue?: string
}

export const TrainingTopicContent: FC<ITrainingTopicContentProps> = ({
  selectedTopicId,
  sections,
  expandedSections,
  onToggleSection,
  searchValue,
}) => {
  const currentSections = sections
    .filter((section) => section.TopicId === selectedTopicId)
    .sort((a, b) => a.Order - b.Order)

  if (!currentSections.length) {
    return (
      <div className={styles.empty}>
        <div className={styles.empty__title}>
          <Translation text={TRANSLATION_KEYS.noData} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.accordion}>
      {currentSections.map((section) => {
        const isExpanded = expandedSections.includes(section.Title)

        return (
          <div
            key={`${section.TopicId}-${section.Title}`}
            className={classNames(styles.accordionItem, {
              [styles.accordionItem_expanded]: isExpanded,
            })}
          >
            <button
              className={styles.accordionHeader}
              onClick={() => onToggleSection(section.Title)}
              type="button"
            >
              <span className={styles.accordionHeader__left}>
                {section.Title && (
                  <TrainingCentreHighlight
                    word={searchValue}
                    className={styles.accordionHeader__title}
                  >
                    {section.Title}
                  </TrainingCentreHighlight>
                )}
              </span>

              <i
                className={classNames(
                  isExpanded ? 'kbase kbase-omni-chevron-up' : 'kbase kbase-omni-chevron-down',
                  styles.accordionHeader__icon
                )}
              />
            </button>

            {isExpanded && (
              <div className={styles.accordionBody}>
                {section.Description && (
                  <TrainingCentreHighlight
                    word={searchValue}
                    className={styles.accordionBody__description}
                  >
                    {section.Description}
                  </TrainingCentreHighlight>
                )}

                <div className={styles.actions}>
                  {section.VideoUrl && (
                    <a
                      className={styles.actionLink}
                      href={section.VideoUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <VideoIcon className={styles.actionLink__icon} />

                      <Translation span text={TRANSLATION_KEYS.watchVideo} />
                    </a>
                  )}

                  {section.SlidesUrl && (
                    <a
                      className={styles.actionLink}
                      href={section.SlidesUrl}
                      target="_blank"
                      rel="noreferrer"
                      download
                    >
                      <SlidesIcon className={styles.actionLink__icon} />

                      <Translation span text={TRANSLATION_KEYS.slides} />
                    </a>
                  )}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
